// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowActivitiesItem-moduleEmailTableRowActivitiesItem__JG5Ku";
export { _1 as "EmailTableRowActivitiesItem" }
